import { createSlice } from "@reduxjs/toolkit";
import { E_MainLato, E_ColoriMetallo } from "../../components/Utils/enumerations";

export const uiMainMenuSlice = createSlice({
    name: "UI_Main_menu",
    initialState: {
        canDrawElements: true,
        lunghezza: 2.0,
        larghezza: 2.0,
        ingresso: E_MainLato.Scegli.toString(),       
        coloreStrutture: E_ColoriMetallo.Antracite.toString(),
    },
    reducers: {
        handleLunghezza: (state, action) => {
            state.lunghezza = action.payload;         
        },
        handleLarghezza: (state, action) => {
            state.larghezza = action.payload;           
        },
        handleIngresso: (state, action) => {
            state.ingresso = action.payload.toString();
        },
        handleColoreStrutture: (state, action) => {
            state.coloreStrutture = action.payload.toString();
        },
        handleCanDrawElements: (state, action) => {
            state.canDrawElements = action.payload;
        }
    }
});

export const { handleLunghezza, handleLarghezza, handleIngresso, handleColoreStrutture, handleCanDrawElements } = uiMainMenuSlice.actions;

export default uiMainMenuSlice.reducer;